import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { TimelineItemLayout } from "web_myplann/NotificationCenter/Components/TimelineItemLayout";
import {
	formatTimelineDate,
	formatTimelineTime,
} from "web_myplann/NotificationCenter/Utils/formatTimelineDate";

interface ResolvingNowItemProps {
	item: TimelineItemResponseDTO;
	onClick?: (item: TimelineItemResponseDTO) => void;
	isLast?: boolean;
}

// Unlike the timeline buckets, "ResolvingNow" has no heading stating the day,
// so each row carries the full date. The time goes on a second line to keep
// the date column from crowding out the title.
export const ResolvingNowItem: FC<ResolvingNowItemProps> = ({
	item,
	onClick,
	isLast = false,
}) => (
	<TimelineItemLayout
		item={item}
		dateLine={formatTimelineDate(item.date)}
		secondaryDateLine={item.time ? formatTimelineTime(item.time) : undefined}
		showChevron={!!onClick}
		disabled={!onClick}
		onClick={onClick ? () => onClick(item) : undefined}
		isLast={isLast}
		data-testid={`resolving-now-item-${item.id}`}
	/>
);
